import React from 'react';

const Footer = () => {
    return (
        <div>
            <p><small>©️Rabiul Rafee || 2024</small></p>
        </div>
    );
};

export default Footer;